import { Card, Space } from "antd";
import { ServiceCard } from "./components";

const SubscriptionsList = () => {
  return (
    <Space direction="vertical">
      <div>消息订阅管理</div>
      <ServiceCard title="箱门未关消息通知推送" />
      <ServiceCard title="滞留消息通知推送" />
    </Space>
  );
};

export default SubscriptionsList;
